module.exports = __webpack_public_path__ + "static/media/feature.14bed712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Churchview/feature.jpg
// module id = 225
// module chunks = 0